export default theme => ({
  fullWidth: {
    width: "100%",
  },
  section: {
    maxWidth: 1500,
    margin: "auto",
  },
  button_container: {
    display: "flex",
    justifyContent: "center",
  },
  date_picker: {
    minWidth: 134,
  },
  flex: {
    display: "flex",
    gap: theme.spacing(4),
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  },
  form__serverError: {
    color: theme.palette.secondary.main,
    margin: 20,
  },
});
